import { render, staticRenderFns } from "./SushiInfo.vue?vue&type=template&id=287e0c99&scoped=true"
import script from "./SushiInfo.vue?vue&type=script&lang=js"
export * from "./SushiInfo.vue?vue&type=script&lang=js"
import style0 from "./SushiInfo.vue?vue&type=style&index=0&id=287e0c99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e0c99",
  null
  
)

export default component.exports